// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"tj_a bii_b bii_bj","HomeBaseBanner__hint":"tj_b bii_vh","HomeBaseBanner__link":"tj_c"};